import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { HashLink } from "react-router-hash-link";
import { Link } from 'react-router-dom';
import './Header.css';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth, firestore } from '../firebase/firebaseConfig';
import { onSnapshot, doc } from "@firebase/firestore";

function Header ( props ) {
  let [ login, setLogin ] = useState( false );
  let [ name, setName ] = useState( "" );

  useEffect( () => {
    onAuthStateChanged( auth, async ( user ) => {
      if ( user ) {
        onSnapshot( doc( firestore, "users", user.uid ), ( snapshot ) => {
          if ( snapshot.exists() ) {
            props.setLogin( true );
            setLogin( true );
            setName( snapshot.data().name );
            props.settingDetails( {
              name: snapshot.data().name,
              phone: snapshot.data().mobile,
              email: snapshot.data().email,
              address: snapshot.data().address,
              pincode: snapshot.data().pincode
            } )
          }
        } );
      }
    } );
  }, [] )

  function navbar_close () {
    document.querySelector( ".navbar-collapse" ).classList.remove( "show" );
    document.querySelector( ".navbar-toggler" ).classList.add( "collapsed" );
  }

  return (
    <Navbar collapseOnSelect expand="lg" bg="light" variant="light" fixed='top'>
      <Container>
        <Navbar.Brand href="/"><img src={require( "../images/logo.webp" )} alt="" /></Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
          </Nav>
          <Nav>
            <HashLink to="/#home" className='nav-link' onClick={event => {
              document.querySelectorAll( ".navbar-nav .nav-link" ).forEach( ( element ) => {
                element.classList.remove( "active" );
              } )
              event.target.classList.add( "active" );
              document.querySelector( ".navbar-toggler" ).click();
            }}>Home</HashLink>
            <HashLink to="/#services" className='nav-link' onClick={event => {
              document.querySelectorAll( ".navbar-nav .nav-link" ).forEach( ( element ) => {
                element.classList.remove( "active" );
              } )
              event.target.classList.add( "active" );
              document.querySelector( ".navbar-toggler" ).click();
            }}>Services</HashLink>
            <Link to="/pricing" className='nav-link' onClick={event => {
              document.querySelectorAll( ".navbar-nav .nav-link" ).forEach( ( element ) => {
                element.classList.remove( "active" );
              } )
              event.target.classList.add( "active" );
              document.querySelector( ".navbar-toggler" ).click();
            }}>Pricing</Link>
            <HashLink to="/#howitworks" className='nav-link' onClick={event => {
              document.querySelectorAll( ".navbar-nav .nav-link" ).forEach( ( element ) => {
                element.classList.remove( "active" );
              } )
              event.target.classList.add( "active" );
              document.querySelector( ".navbar-toggler" ).click();
            }}>How It Works</HashLink>
            <Link to="/franchise" className='nav-link' onClick={event => {
              document.querySelectorAll( ".navbar-nav .nav-link" ).forEach( ( element ) => {
                element.classList.remove( "active" );
              } )
              event.target.classList.add( "active" );
              document.querySelector( ".navbar-toggler" ).click();
            }}>Partner With Us</Link>
            <Link to="/contact" className='nav-link' onClick={event => {
              document.querySelectorAll( ".navbar-nav .nav-link" ).forEach( ( element ) => {
                element.classList.remove( "active" );
              } )
              event.target.classList.add( "active" );
              document.querySelector( ".navbar-toggler" ).click();
            }}>Contact Us</Link>
            {login === true && <Link to="/wallet" className='nav-link wallet-link' onClick={event => {
              document.querySelectorAll( ".navbar-nav .nav-link" ).forEach( ( element ) => {
                element.classList.remove( "active" );
              } )
              event.target.classList.add( "active" );
              document.querySelector( ".navbar-toggler" ).click();
            }}>
              <svg width="18" height="15" viewBox="0 0 28 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24.6734 5.90462V3.23796H3.34001V21.9046H24.6734V19.238H14.0067C13.2703 19.238 12.6734 18.641 12.6734 17.9046V7.23796C12.6734 6.50158 13.2703 5.90462 14.0067 5.90462H24.6734ZM2.00667 0.571289H26.0067C26.7431 0.571289 27.34 1.16825 27.34 1.90462V23.238C27.34 23.9744 26.7431 24.5713 26.0067 24.5713H2.00667C1.2703 24.5713 0.67334 23.9744 0.67334 23.238V1.90462C0.67334 1.16825 1.2703 0.571289 2.00667 0.571289ZM15.34 8.57129V16.5713H24.6734V8.57129H15.34ZM18.0067 11.238H22.0067V13.9046H18.0067V11.238Z" fill="#444444" />
              </svg>
              <span>LB Wallet</span>
            </Link>}
            {login === false && <Button className='login-link-button' variant='outline-light' onClick={event => { window.location.href = "/login"; }}>Log In</Button>}
            {login === true && <NavDropdown title={"Hi " + name.split( " " )[ 0 ].substring( 0, 15 )} id="basic-nav-dropdown">
              <NavDropdown.Item><Link onClick={event => {
                document.querySelectorAll( ".navbar-nav .nav-link" ).forEach( ( element ) => {
                  element.classList.remove( "active" );
                } )
                event.target.classList.add( "active" );
                document.querySelector( ".navbar-toggler" ).click();
              }} to="/profile" style={{ textDecoration: "none", fontSize: "18px", fontWeight: "500" }}>Profile</Link></NavDropdown.Item>
              <NavDropdown.Item><Link onClick={event => {
                document.querySelectorAll( ".navbar-nav .nav-link" ).forEach( ( element ) => {
                  element.classList.remove( "active" );
                } )
                event.target.classList.add( "active" );
                document.querySelector( ".navbar-toggler" ).click();
              }} to="/cart" style={{ textDecoration: "none", fontSize: "18px", fontWeight: "500" }}>My Cart</Link></NavDropdown.Item>
              <NavDropdown.Item><Link onClick={event => {
                document.querySelectorAll( ".navbar-nav .nav-link" ).forEach( ( element ) => {
                  element.classList.remove( "active" );
                } )
                event.target.classList.add( "active" );
                document.querySelector( ".navbar-toggler" ).click();
              }} to="/orders" style={{ textDecoration: "none", fontSize: "18px", fontWeight: "500" }}>My Orders</Link></NavDropdown.Item>
              <NavDropdown.Item style={{ textDecoration: "none", fontSize: "18px", fontWeight: "500" }} onClick={event => {
                signOut( auth );
                window.location.href = "/";
                window.location.reload();
              }}>Log Out</NavDropdown.Item>
            </NavDropdown>}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header